module.exports = {
  "props": [],
  "mixins": [],
  "slots": [],
  "events": [],
  "functions": [],
  "name": "v-breadcrumbs-divider",
  "sass": [],
  "component": true
}